/* Money Guides theme — front-end behaviour
   Cart drawer, mobile menu, AJAX add-to-cart, qty input, accordion.
   Vanilla JS, no dependencies. */
(function () {
  'use strict';

  const $  = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  // ---------- Cart drawer ----------
  const drawer       = $('[data-cart-drawer]');
  const drawerOverlay= $('[data-cart-overlay]');
  const drawerItems  = $('[data-cart-items]');
  const drawerSubtotal = $('[data-cart-subtotal]');

  function openDrawer()  { drawer && drawer.classList.add('is-open'); drawerOverlay && drawerOverlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer && drawer.classList.remove('is-open'); drawerOverlay && drawerOverlay.classList.remove('is-open'); document.body.style.overflow = ''; }

  $$('[data-open-cart]').forEach(el => el.addEventListener('click', (e) => {
    if (drawer) { e.preventDefault(); openDrawer(); refreshCart(); }
  }));
  $$('[data-close-cart]').forEach(el => el.addEventListener('click', closeDrawer));
  drawerOverlay && drawerOverlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  // ---------- Mobile menu ----------
  const menu = $('[data-mobile-menu]');
  function openMenu()  { menu && menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { menu && menu.classList.remove('is-open'); document.body.style.overflow = ''; }
  $$('[data-open-menu]').forEach(el => el.addEventListener('click', openMenu));
  $$('[data-close-menu]').forEach(el => el.addEventListener('click', closeMenu));

  // ---------- AJAX cart ----------
  async function refreshCart() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      updateCartUI(cart);
    } catch (err) { console.error('cart fetch failed', err); }
  }

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active === 'INR') ? '₹' + amount : '$' + amount;
  }

  function updateCartUI(cart) {
    $$('[data-cart-count]').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    if (drawerItems) {
      if (cart.item_count === 0) {
        drawerItems.innerHTML = '<p class="muted">Your cart is empty.</p>';
      } else {
        drawerItems.innerHTML = cart.items.map(item => `
          <div class="cart-line" data-key="${item.key}">
            <div class="cart-line__media">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
            <div>
              <div class="cart-line__title">${item.product_title}</div>
              ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__price">${item.variant_title}</div>` : ''}
              <div class="qty-input" style="margin-top:8px">
                <button type="button" data-qty-decrease aria-label="Decrease">−</button>
                <input type="text" value="${item.quantity}" data-qty readonly>
                <button type="button" data-qty-increase aria-label="Increase">+</button>
              </div>
              <a href="#" class="cart-line__remove" data-remove>Remove</a>
            </div>
            <div class="cart-line__price">${formatMoney(item.final_line_price)}</div>
          </div>
        `).join('');
      }
    }
    if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    bindLineEvents();
  }

  function bindLineEvents() {
    $$('[data-cart-items] .cart-line').forEach(line => {
      const key = line.dataset.key;
      $('[data-qty-increase]', line)?.addEventListener('click', () => updateQty(key, +line.querySelector('[data-qty]').value + 1));
      $('[data-qty-decrease]', line)?.addEventListener('click', () => updateQty(key, Math.max(0, +line.querySelector('[data-qty]').value - 1)));
      $('[data-remove]', line)?.addEventListener('click', (e) => { e.preventDefault(); updateQty(key, 0); });
    });
  }

  async function updateQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      refreshCart();
    } catch (err) { console.error(err); }
  }

  // ---------- Add to cart ----------
  $$('[data-add-to-cart-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      // If Buy Now was clicked, let the default form post happen so Shopify
      // adds the item and redirects to /checkout.
      if (form.getAttribute('data-skip-ajax') === '1') return;
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      const original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });
        if (!res.ok) throw new Error('add failed');
        await refreshCart();
        if (drawer) openDrawer(); else window.location.href = '/cart';
      } catch (err) {
        console.error(err);
        if (btn) btn.textContent = 'Try again';
      } finally {
        if (btn) { btn.disabled = false; setTimeout(() => { btn.textContent = original; }, 1500); }
      }
    });
  });

  // ---------- Product page qty input ----------
  $$('[data-product-qty]').forEach(group => {
    const input = $('input', group);
    $('[data-qty-decrease]', group)?.addEventListener('click', () => { input.value = Math.max(1, +input.value - 1); });
    $('[data-qty-increase]', group)?.addEventListener('click', () => { input.value = +input.value + 1; });
  });

  // ---------- Product thumbnails ----------
  $$('[data-product-thumb]').forEach(thumb => {
    thumb.addEventListener('click', (e) => {
      e.preventDefault();
      const main = $('[data-product-main-image]');
      if (main) main.src = thumb.dataset.fullSrc || thumb.querySelector('img').src;
    });
  });

  // ---------- Variant change ----------
  $$('[data-variant-select]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);

      const opt = select.options[select.selectedIndex];
      const form = select.closest('form');
      // Update Add-to-cart button price (the one with name="add")
      if (form) {
        const addBtn = form.querySelector('button[name="add"]');
        if (addBtn && opt && opt.dataset.price) addBtn.textContent = 'Add to cart — ' + opt.dataset.price;
      }

      // Cover color swap (Student edition: Girl → pink, Boy → blue)
      const cover = document.querySelector('[data-variant-cover]');
      if (cover && opt && opt.dataset.cover) {
        cover.classList.remove('product-card__media--serious', 'product-card__media--generic', 'product-card__media--feminine');
        cover.classList.add('product-card__media--' + opt.dataset.cover);
      }
    });
  });

  // ---------- Buy Now button — bypass cart drawer ----------
  // When user clicks 'Buy now' (name="checkout"), let the form submit naturally
  // so Shopify adds the item and redirects to /checkout. We just need to NOT intercept it.
  $$('[data-add-to-cart-form] button[name="checkout"]').forEach(btn => {
    btn.addEventListener('click', (e) => {
      // Tag the form so the AJAX handler skips it
      btn.closest('form')?.setAttribute('data-skip-ajax', '1');
    });
  });

  // ---------- Initial cart sync (badge) ----------
  refreshCart();
})();
